module.exports = __webpack_public_path__ + "e348815bf5ede34eaa2a730b185b8c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/i/i04.jpg
// module id = 608
// module chunks = 0